<template>
  <table class="w-full text-xs bg-white border border-gray-200">
    <thead>
      <tr class="bg-gray-50 border-b border-gray-200 text-left text-gray-500">
        <th class="p-2 font-medium">Pull request</th>
        <th class="p-2 font-medium">Title</th>
        <th class="p-2 font-medium">Delivery</th>
        <th class="p-2 font-medium">Customer link</th>
        <th class="p-2 font-medium">Engineer</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!pullRequests.length">
        <td colspan="5" class="p-2 text-gray-500">No pull requests in this category.</td>
      </tr>
      <tr
        v-for="pr in pullRequests"
        :key="pr.id"
        class="border-b border-gray-100 cursor-pointer"
        :class="pr.id === selectedId ? 'bg-gray-100' : 'hover:bg-gray-50'"
        @click="$emit('select', pr.id)"
      >
        <td class="p-2">
          <a
            :href="pr.url"
            target="_blank"
            rel="noopener"
            class="text-primary-700 hover:underline"
            @click.stop
          >{{ pr.repository }}#{{ pr.pr_number }}</a>
        </td>
        <td class="p-2">{{ pr.title }}</td>
        <td class="p-2 text-gray-600">{{ deliveryLabel(pr.delivery_state) }}</td>
        <!-- Weight, not colour: an unlinked PR is a fact to scan down a column,
             not an error. -->
        <td class="p-2" :class="hasRequirement(pr) ? 'font-medium' : 'text-gray-400'">
          {{ linkageLabel(pr.customer_linkage) }}
        </td>
        <td class="p-2 text-gray-600">{{ pr.engineer_id || pr.author_login || '—' }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { DELIVERY_LABELS, LINKAGE_LABELS, label } from './hades_constants';

export default {
  name: 'Hades_PRTable',
  props: {
    pullRequests: { type: Array, required: true },
    selectedId: { type: Number, default: null },
  },
  emits: ['select'],
  methods: {
    hasRequirement(pr) {
      return !!(pr.requirement_ids && pr.requirement_ids.length);
    },
    deliveryLabel(delivery) {
      return label(DELIVERY_LABELS, delivery);
    },
    linkageLabel(linkage) {
      return label(LINKAGE_LABELS, linkage);
    },
  },
};
</script>
